import { useState, useEffect } from 'react'
import Joyride, { ACTIONS, EVENTS, CallBackProps, Step } from 'react-joyride'
import { SimpleTooltip } from './simpleTooltip'
import { useTranslator } from '../translator/hook'
import './downloadTutorial.css'

interface DownloadTutorialProps {
  run: boolean
  onComplete: () => void
}

export const DownloadTutorial = ({
  run,
  onComplete,
}: DownloadTutorialProps) => {
  const [stepIndex, setStepIndex] = useState(0)
  const { t } = useTranslator()

  // 擬似的にビーコンを追加するための属性を付与する
  useEffect(() => {
    if (run) {
      document.body.setAttribute('data-download-tutorial-active', 'true')
    } else {
      document.body.removeAttribute('data-download-tutorial-active')
    }

    return () => {
      document.body.removeAttribute('data-download-tutorial-active')
    }
  }, [run])

  const downloadTutorialSteps: Step[] = [
    {
      target: '.download-small-button',
      content: '',
      disableBeacon: true, // CSSで擬似的にビーコンを表示
      placement: 'bottom',
      spotlightClicks: true,
      disableOverlayClose: true,
      disableCloseOnEsc: true,
      hideBackButton: true,
      hideCloseButton: true,
      spotlightPadding: 0,
      data: {
        content1: t('download_and_start_mission'),
        hideButton: true,
        content1Style: 'simpleTooltipText1NoAnim',
        buttonLabel: undefined,
      },
    },
  ]

  const handleTutorialCallback = (data: CallBackProps) => {
    const { action, index, type } = data

    if (type === EVENTS.TOOLTIP && action === ACTIONS.CLOSE) {
      onComplete()
      return
    }

    if (type === EVENTS.TARGET_NOT_FOUND) {
      onComplete()
      return
    }

    if (type === EVENTS.TOUR_END) {
      onComplete()
      return
    }

    if (type === EVENTS.STEP_AFTER) {
      const currentIndex = index + (action === ACTIONS.PREV ? -1 : 1)
      setStepIndex(currentIndex)
      const stepsCount = downloadTutorialSteps.length
      if (currentIndex === stepsCount) {
        onComplete()
      }
    }
  }

  return (
    <Joyride
      callback={handleTutorialCallback}
      steps={downloadTutorialSteps}
      stepIndex={stepIndex}
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      tooltipComponent={(props: any) => <SimpleTooltip {...props} />}
      spotlightClicks={true}
      continuous={true}
      run={run}
      disableOverlayClose={true}
      disableCloseOnEsc={true}
      hideBackButton={true}
      hideCloseButton={true}
      disableScrollParentFix={true}
      disableScrolling={true}
      scrollToFirstStep={false}
      disableOverlay={false}
      styles={{
        options: {
          arrowColor: 'transparent',
          zIndex: 999999,
          beaconSize: 16,
          primaryColor: '#FF6B35',
        },
        overlay: { height: '100vh', width: '100vw' },
        spotlight: {
          borderRadius: '8px',
        },
      }}
      floaterProps={{
        disableAnimation: true,
      }}
    />
  )
}
